import { childrenBusinessPageBreadcrumbs } from '../../config';
import { usePickUpDetail, usePickUpChildren } from './hooks';
import { useParams, useNavigate } from 'react-router-dom';
import { NavigateLinks, Table } from '@/components';
import { CircularProgress } from '@mui/material';
import { pickUpDetailColumns } from './config';
import { useMemo, useState } from 'react';

const DEFAULT_PAGE_SIZE = 10;

const PickUpDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const { pickUp, isLoading: isLoadingVisit, error: visitError } = usePickUpDetail({
    id,
    skip: !id,
  });

  const parentShippingNumber = pickUp?.shippings?.[0]?.number;
  const { children, totalItems, totalPages, isLoading: isLoadingChildren, error: childrenError } =
    usePickUpChildren({
      shippingNumber: parentShippingNumber,
      page: currentPage,
      pageSize,
      skip: !parentShippingNumber,
    });

  const parentBreadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const breadcrumbs = useMemo(
    () => [
      ...parentBreadcrumbs,
      { label: 'Retiros Flex', to: '/business/pickup' },
    ],
    [parentBreadcrumbs]
  );

  const isLoading = isLoadingVisit || isLoadingChildren;
  const hasError = visitError || childrenError;

  return (
    <section className="w-full h-full flex flex-col gap-10 mb-12 p-5">
      <NavigateLinks actualPage="Pedidos Pickeados" breadcrumbs={breadcrumbs} />

      <div className="w-full flex flex-col gap-5">
        <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
          {isLoading && (
            <div className="flex flex-col items-center justify-center py-12 gap-3">
              <CircularProgress color="primary" />
              <span className="text-gray-500 text-sm font-medium">Cargando pedidos...</span>
            </div>
          )}

          {hasError && !isLoading && (
            <div className="text-center py-6 text-red-700 bg-red-100 rounded-lg border border-red-300">
              Ocurrió un error al cargar los pedidos
            </div>
          )}

          {!isLoading && !hasError && children.length === 0 && (
            <div className="text-center py-6 text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
              No hay pedidos pickeados para esta visita
            </div>
          )}

          {!isLoading && !hasError && children.length > 0 && (
            <Table
              columns={pickUpDetailColumns}
              data={children}
              isLoading={false}
              stickyHeader
              pagination={{
                totalItems,
                totalPages,
                currentPage,
                rowsPerPage: pageSize,
                onPageChange: setCurrentPage,
                onRowsPerPageChange: (size) => { setPageSize(size); setCurrentPage(1); },
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default PickUpDetail;
